import colors from './colors'
import typography from './typography'
import palette from './palette'

export default {
  MuiPickersToolbar: {
    toolbar: { padding: 16 },
  },
  MuiPickersYear: {
    yearSelected: { ...typography.h3 },
  },
  MuiPaper: {
    root: {
      boxShadow:
        '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
      backgroundColor: palette.common.white,
    },
    rounded: {
      borderRadius: 4,
    },
  },
  MuiButton: {
    root: {
      borderRadius: 20,
      padding: '24px 24px 24px 24px',
      lineHeight: '20px',
    },
    contained: {
      boxShadow: '0px 8px 30px rgba(0,0,0, 0.1)',
    },
    label: {
      textTransform: 'none',
      fontWeight: 'bold',
    },
    containedPrimary: {
      '&:hover': {
        backgroundColor: colors.lightYellow,
      },
    },
    containedSecondary: {
      backgroundColor: colors.greys.medium,
      '&:hover': {
        backgroundColor: colors.greys.mediumLight,
      },
    },
    outlined: {
      borderRadius: 20,
      height: '60px',
      padding: '5px 20px',
      border: `3px solid ${colors.black}`,
    },
  },
  MuiTooltip: {
    tooltip: {
      padding: '8px',
      fontSize: '0.725rem',
      fontWeight: 550,
    },
  },
  MuiCard: {
    root: {
      boxShadow: '0px 25px 40px rgba(0,0,0, 0.1)',
    },
  },
  MuiLinearProgress: {
    width: '100%',
    colorPrimary: {
      backgroundColor: colors.greys.lighter,
    },
    barColorPrimary: {
      backgroundColor: colors.yellow,
    },
  },
  MuiBackdrop: {
    root: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
  },
}
